import request from "@/services/request"

const api = {
    postDataBind: "/v1/pda/data_bind",
    postQueryDataBind: "/v1/pda/query_data_bind",
    getInRepositoryList: "/v1/repository-in-detail?pageIndex=1&pageSize=100&beginTime=&endTime=&status=0",
    getOutRepositoryList: "/v1/repository-out-detail?pageIndex=1&pageSize=100&beginTime=&endTime=&status=0",
    getProductList: "/v1/code-products?pageIndex=1&pageSize=100&beginTime=&endTime=",
    getDealerList: "/v1/dealer-detail?pageIndex=1&pageSize=100&beginTime=&endTime=&status=1",
    getStoreList: "/v1/store-detail?pageIndex=1&pageSize=100&beginTime=&endTime=&status=1",
    codeLength: "/v1/app-config/repository_code_length",
    countInByCodes: "/v1/pda/count_in_by_codes",
    countOutByCodes: "/v1/pda/count_out_by_codes",
    countBackByCodes: "/v1/pda/count_back_by_codes",
    ratailBackByCodes: "/v1/pda/count_ratail_by_codes",
    inRepository: "/v1/pda/in_repository",
    outRepository: "/v1/pda/out_repository",
    ratailRepository: "/v1/pda/ratail_repository",
    backRepository: "/v1/pda/back_repository",
}

export function postDataBind(params) {
    return request({
        url: api.postDataBind,
        method: "post",
        data: params
    })
}

export function getInRepositoryList(params) {
    return request({
        url: api.getInRepositoryList,
        method: "get",
        params
    })
}

export function countInByCodes(params) {
    return request({
        url: api.countInByCodes,
        method: "post",
        data: params
    })
}

export function inRepository(params) {
    return request({
        url: api.inRepository,
        method: "post",
        data: params
    })
}

export function countBackByCodes(params) {
    return request({
        url: api.countBackByCodes,
        method: "post",
        data: params
    })
}

export function backRepository(params) {
    return request({
        url: api.backRepository,
        method: "post",
        data: params
    })
}

export function getProductList(params) {
    return request({
        url: api.getProductList,
        method: "get",
        params
    })
}

export function getDealerList(params) {
    return request({
        url: api.getDealerList,
        method: "get",
        params
    })
}

export function getStoreList(params) {
    return request({
        url: api.getStoreList,
        method: "get",
        params
    })
}

export function getCodeLengthApi() {
    return request({
        url: api.codeLength,
        method: "get",
    })
}

export function getOutRepositoryList(params) {
    return request({
        url: api.getOutRepositoryList,
        method: "get",
        params
    })
}

export function countOutByCodes(params) {
    return request({
        url: api.countOutByCodes,
        method: "post",
        data: params
    })
}

export function countRatailByCodes(params) {
    return request({
        url: api.ratailBackByCodes,
        method: "post",
        data: params
    })
}

export function outRepository(params) {
    return request({
        url: api.outRepository,
        method: "post",
        data: params
    })
}

export function ratailOutRepository(params) {
    return request({
        url: api.ratailRepository,
        method: "post",
        data: params
    })
}

export function QueryBindData(params) {
    return request({
        url: api.postQueryDataBind,
        method: "post",
        data: params
    })
}